import Vue from 'vue'
import CF from '../../../static/config'
import api from '../../services/service'
var numeral = require('numeral')
var moment = require('moment')
const ThaiBaht = require('thai-baht-text')

Vue.mixin({
  data () {
    return {
      CompanyConfig: CF,
      branchData: []
    }
  },
  methods: {
    checkUser () {
      if (sessionStorage.user) {
        this.$store.state.token = sessionStorage.token
        this.$store.state.user = JSON.parse(sessionStorage.user)
      } else {
        this.$store.commit('clearState')
        window.location = '/login'
      }
    },
    getBranch () {
      api.branchList(sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        result => {
          if (result.response === 'success') {
            this.$store.state.branch_list = result.data
          } else {
            this.alert_msg('warning', 'เข้าสู่ระบบ', result.message)
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getLastDate (Data) {
      var res = Data.split('-')
      var month = res[1] // January
      var year = res[0]
      var d = new Date(year, month, 0)
      return moment(d).format('DD')
    },
    dateYearThai (date) {
      return moment(date).format('YYYY')
    },
    dateMonth (date) {
      return moment(date).format('YYYY-MM')
    },
    alert_msg (type, title, text) {
      this.$notice[type]({
        title: title,
        description: text
      })
    },
    ToDoDev () {
      this.alert_msg('warning', 'แจ้งเตือนระบบ', 'ระบบกำลังพัฒนาอยู่นะจ๊ะ *_*!')
    },
    dateFormatAndTime (date) {
      moment.locale()
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    dateFormatAndTimeDat (date) {
      moment.locale()
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateDMY (date) {
      return moment(date).format('YYYYMMDD')
    },
    dateFormat (date) {
      moment.locale()
      return moment(date).format('L')
    },
    dateFormatDMY (date) {
      moment.locale()
      return moment(date).format('DD/MM/YYYY')
    },
    dateFormatDMY2 (date) {
      moment.locale()
      return moment(date).format('YYYY-MM-DD')
    },
    dateFormatMY (date) {
      moment.locale()
      return moment(date).format('MM/YYYY')
    },
    monthFormat (str) {
      switch (str) {
        case '01':
          return 'ม.ค'
        case '02':
          return 'ก.พ'
        case '03':
          return 'มี.ค'
        case '04':
          return 'เม.ย'
        case '05':
          return 'พ.ค'
        case '06':
          return 'มิ.ย'
        case '07':
          return 'ก.ค'
        case '08':
          return 'ส.ค'
        case '09':
          return 'ก.ย'
        case '10':
          return 'ต.ค'
        case '11':
          return 'พ.ย'
        default:
          return 'ธ.ค'
      }
    },
    monthYearFormat (str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0]
        case '02':
          return 'กุมภาพันธ์ ' + date[0]
        case '03':
          return 'มีนาคม ' + date[0]
        case '04':
          return 'เมษายน ' + date[0]
        case '05':
          return 'พฤษภาคม ' + date[0]
        case '06':
          return 'มิถุนายน ' + date[0]
        case '07':
          return 'กรกฎาคม ' + date[0]
        case '08':
          return 'สิงหาคม ' + date[0]
        case '09':
          return 'กันยายน ' + date[0]
        case '10':
          return 'ตุลาคม ' + date[0]
        case '11':
          return 'พฤศจิกายน ' + date[0]
        default:
          return 'ธันวาคม ' + date[0]
      }
    },
    dateFullFormat (str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return date[2] + ' มกราคม ' + date[0]
        case '02':
          return date[2] + ' กุมภาพันธ์ ' + date[0]
        case '03':
          return date[2] + ' มีนาคม ' + date[0]
        case '04':
          return date[2] + ' เมษายน ' + date[0]
        case '05':
          return date[2] + ' พฤษภาคม ' + date[0]
        case '06':
          return date[2] + ' มิถุนายน ' + date[0]
        case '07':
          return date[2] + ' กรกฎาคม ' + date[0]
        case '08':
          return date[2] + ' สิงหาคม ' + date[0]
        case '09':
          return date[2] + ' กันยายน ' + date[0]
        case '10':
          return date[2] + ' ตุลาคม ' + date[0]
        case '11':
          return date[2] + ' พฤศจิกายน ' + date[0]
        default:
          return date[2] + ' ธันวาคม ' + date[0]
      }
    },
    numberFormatDecimal (str) {
      return numeral(str).format('0,0.00')
    },
    numberFormat (str) {
      return numeral(str).format('0,0')
    },
    moneyText (str) {
      return ThaiBaht(str)
    },
    convert_vs (val) {
      var data = []
      var len = 3
      if (val.length > 3) {
        len = val.length
      }
      var vallen = val.length
      for (var i = 0; i < len; i++) {
        var v = val.split('')
        if (len - i === vallen) {
          var ss = len - i
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val)
            } else {
              if (len > val.length) {
                data.push(v[i - 1])
              } else {
                data.push(v[i])
              }
            }
          } else {
            data.push(v[i - 1])
          }
          vallen--
        } else {
          data.push('0')
        }
      }
      var versions = ''
      for (var l = 0; l < data.length; l++) {
        versions += data[l]
        if (l < data.length - 1) {
          versions += '.'
        }
      }
      return versions
    },
    getParam (param) {
      var url = new URL(window.location.href)
      var c = url.searchParams.get(param)
      return c
    },
    convertTitleCalendar (str) {
      const date = str.split(' ')
      switch (date[0]) {
        case 'มกราคม':
          return '01-' + date[1]
        case 'กุมภาพันธ์':
          return '02-' + date[1]
        case 'มีนาคม':
          return '03-' + date[1]
        case 'เมษายน':
          return '04-' + date[1]
        case 'พฤษภาคม':
          return '05-' + date[1]
        case 'มิถุนายน':
          return '06-' + date[1]
        case 'กรกฎาคม':
          return '07-' + date[1]
        case 'สิงหาคม':
          return '08-' + date[1]
        case 'กันยายน':
          return '09-' + date[1]
        case 'ตุลาคม':
          return '10-' + date[1]
        case 'พฤศจิกายน':
          return '11-' + date[1]
        default:
          return '12-' + date[1]
      }
    },
    colorItemDefalt (val) {
      switch (val) {
        case 0:
          return 'white'
        case 1:
          return 'green'
        default:
          return 'white'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js